import type { GeneralResp } from '@/models/GeneralResp';
import type { AxiosResponse } from 'axios';
import * as ApiClient from '@/libs/ApiClient';
import { RouteUrlList } from '@/libs/RouteList';
export interface Ibranch {
    bid: string;
    bnm: string;
}
/**
 * @todo 檢查 單一分公司
 */
export interface CheckBidResp extends GeneralResp {
    bid: string;
}

/**
 * @todo 檢查 單一分公司
 */
const CheckBid = (ssn: string): Promise<CheckBidResp> => {
    const data = {
        ssn: ssn
    };
    const url = RouteUrlList.API_CheckBid.path;
    const config = {
        params: {
            showOverlay: ApiClient.paramTypeEnum.true,
            skipIdletimeout: ApiClient.paramTypeEnum.true,
            getServiceAlert: ApiClient.paramTypeEnum.true
        }
    };
    return ApiClient.post(url, data, config).then((res: AxiosResponse<CheckBidResp>) => {
        return res.data;
    });
};

export default CheckBid;
